export default function scrollPageTo(section, block) {
  const heading = document.getElementById(section);
  heading.scrollIntoView({ behavior: "smooth", block });
}
